import {
  GET_LIST_DANHSACHNHANVIEN,
  GET_LIST_DANHSACHNHANVIEN_SUCCESS,
  GET_LIST_DANHSACHNHANVIEN_FAILURE,
} from "actions/DanhSachNhanVien/actionTypes";

const initialState = {
  getListDanhSachNhanVienLoading: false,
  posts: [],
  objList: {
    List: [],
  },
  totalRow: 0,
};

const getListDanhSachNhanVien = (state, action) => ({
  ...state,
  getListDanhSachNhanVienLoading: true,
});

const getListDanhSachNhanVienSuccess = (state, action) => {
  return {
    ...state,
    getListDanhSachNhanVienLoading: false,
    objList: action.payload,
  };
};

const getListDanhSachNhanVienFailed = (state, action) => ({
  ...state,
  getListDanhSachNhanVienLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DANHSACHNHANVIEN:
      return getListDanhSachNhanVien(state, action);
    case GET_LIST_DANHSACHNHANVIEN_SUCCESS:
      return getListDanhSachNhanVienSuccess(state, action);
    case GET_LIST_DANHSACHNHANVIEN_FAILURE:
      return getListDanhSachNhanVienFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
